import React, { useEffect, useState } from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import SliderNavigation from "./SliderNavigation";
import { easeInOutExpo } from "../../utils/animations";

interface Props {
  children: JSX.Element[];
}

const CardSlider = ({ children }: Props) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      initial: 0,
      defaultAnimation: {
        easing: (t) => easeInOutExpo(t),
        duration: 500,
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    [
      // add plugins here
    ]
  );

  return (
    <div>
      {/* desktop view */}
      <div
        sx={{
          display: ["none", null, null, "flex"],
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {children.map((child: any, i: number) => (
          <div
            data-sal="slide-up"
            data-sal-delay={`${i * 150}`}
            data-sal-duration="1000"
            data-sal-easing="easeOutQuart"
            sx={{
              zIndex: 2,
              position: ["relative"],
            }}
            key={i}
          >
            {child}
          </div>
        ))}
      </div>
      {/* mobile view */}
      <div
        // data-sal="slide-up"
        // data-sal-duration="1000"
        // data-sal-easing="easeOutQuart"
        sx={{
          display: ["flex", null, null, "none"],
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div ref={sliderRef} className="keen-slider">
          {children.map((child: any, i: number) => (
            <div
              className={`keen-slider__slide`}
              sx={{
                zIndex: 2,
                width: "100%",
                justifyContent: "center",
                display: "flex",
              }}
              key={i}
            >
              {child}
            </div>
          ))}
        </div>
        <div
          sx={{
            mt: 4,
          }}
        >
          {loaded && instanceRef.current && (
            <SliderNavigation
              instanceRef={instanceRef}
              currentSlide={currentSlide}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CardSlider;
